import React from "react";

import styles from "./HR.module.scss";

/**
 * @param {String} [className] - additonal className to add
 */
const HR = props => <hr className={`${styles.hr} ${props.className || ""}`} />;

export default HR;
